import React from "react";
import { Heart } from "lucide-react";
import { OrnateDivider, Reveal } from "@/components/Ornaments";

const InvitationText = ({ data }) => {
  const inv = data.invitation;
  return (
    <Reveal>
      <section data-testid="invitation-text" className="mx-auto max-w-sm space-y-5 text-center">
        {inv.paragraphs.map((p, i) => (
          <p key={i} className="font-editorial text-[17px] italic leading-relaxed text-[#57534E]">
            {p.text.split("\n").map((line, j) => (
              <React.Fragment key={j}>
                {line}
                {j < p.text.split("\n").length - 1 && <br />}
              </React.Fragment>
            ))}
            {p.heart && (
              <Heart className="mb-0.5 ml-1 inline text-[#D492A6]" width={14} height={14} fill="currentColor" />
            )}
          </p>
        ))}

        <div className="space-y-1.5 pt-2">
          <p className="font-display gold-text text-sm uppercase tracking-[0.18em]">{inv.dateLine}</p>
          <p className="text-sm tracking-[0.08em] text-[#44403C]">{inv.venueLine}</p>
          <p className="text-xs tracking-[0.06em] text-[#78716C]">{inv.addressLine}</p>
        </div>

        <OrnateDivider />

        <p className="font-editorial text-lg italic leading-relaxed text-[#44403C]">
          {inv.closing.split("\n").map((line, j) => (
            <React.Fragment key={j}>
              {line}
              {j < inv.closing.split("\n").length - 1 && <br />}
            </React.Fragment>
          ))}{" "}
          <Heart className="mb-0.5 inline text-[#D492A6]" width={14} height={14} fill="currentColor" />
        </p>
        <p className="font-editorial text-2xl italic text-[#1C1917]">
          {data.names.one} &amp; {data.names.two}
        </p>
      </section>
    </Reveal>
  );
};

export default InvitationText;
